<template>
  <div class="status-icon-wrap">
    <v-icon
      v-if="icon"
      :name="icon"
      class="status-icon"
      :class="iconClass"
      :spin="spin"
    />
  </div>
</template>

<script>
export default {
  name: "CampaignListStatusIcon",
  props: {
    status: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icon: "",
      iconClass: "",
      spin: false
    };
  },
  created() {
    this.setupIcon();
  },
  methods: {
    setupIcon() {
      switch (this.status) {
        case "DOWNLOADED":
          this.icon = "download";
          this.iconClass = "text-brand opacity-50";
          break;

        case "DRAFT":
          this.icon = "pencil-alt";
          this.iconClass = "text-grey";
          break;

        case "SENT":
          this.icon = "check";
          this.iconClass = "text-success";
          break;

        case "ARCHIVED":
          this.icon = "check";
          this.iconClass = "text-grey opacity-50";
          break;

        case "SENDING":
          this.icon = "check";
          this.iconClass = "text-grey opacity-50";
          break;

        case "RELOADING":
          this.icon = "spinner";
          this.iconClass = "text-brand";
          this.spin = true;
          break;

        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.status-icon-wrap {
  @apply w-full mb-2 text-center;

  @screen md {
    @apply mb-2;
  }

  @screen lg {
    @apply m-0 mr-4 w-auto flex;
  }
}

.status-icon {
  font-size: 20px;

  @screen xl {
    font-size: 30px;
  }
}
</style>
